import type { ContainerModule } from '@yandex-int/k-common';
import b from 'b_';
import { Lock } from 'education-icons';
import { Link, Text, useGeneratePath, useStaticUrls } from 'platform-components';
import { UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/src/components/constants';
import { TooltipStateful } from 'platform-components/src/components/LegoTooltip/LegoTooltip';
import qs from 'query-string';
import React, { useRef } from 'react';
import { useParams } from 'react-router';

import { SEARCH_OPEN_MODULE } from 'common.components/constants';

import './course-container__module-link.scss';

interface Props {
    containerModule: ContainerModule;
    titlesOnly?: boolean;
}

interface Params {
    subject: string;
    containerSlug: string;
    classId?: string;
}

export const CourseContainerModuleLink = ({ containerModule, titlesOnly }: Props) => {
    const {
        lessons_count,
        module: { id, name },
    } = containerModule;

    const staticUrls = useStaticUrls();
    const getRouterPath = useGeneratePath();
    const { classId, subject, containerSlug } = useParams<Params>();

    const pathPartDependentOnTheRole = classId
        ? staticUrls.labLibrarySubjectCollection
        : staticUrls.labLibrarySubjectCommonCourseContainer;

    const libraryCollectionPath = getRouterPath(pathPartDependentOnTheRole, {
        containerSlug,
        subject,
    });

    const link = `${libraryCollectionPath}?${qs.stringify({
        [SEARCH_OPEN_MODULE]: id,
    })}`;

    const lockRef = useRef(null);

    const isLocked = lessons_count === 0;

    return (
        <Link
            className={b('course-container', 'module-link-wrapper', { locked: isLocked, links: !titlesOnly })}
            disabled={isLocked}
            isRouter
            key={id}
            pseudo={titlesOnly}
            ref={lockRef}
            to={link}
        >
            <div className="course-container__module-link">
                <TooltipStateful
                    className="course-container__module-link-tooltip"
                    content={<Text id="library.collection.module.link.locked.tooltip" size={Text.SIZE.L} />}
                    direction="top-start"
                    hasTail
                    mainOffset={4}
                    secondaryOffset={-4}
                    tailOffset={-104}
                    trigger={isLocked ? ['hover', 'click'] : []}
                    view="default"
                >
                    <div className="course-container__module-link-inner-wrapper">
                        {isLocked && (
                            <div className="course-container__module-link-lock">
                                <Lock className="course-container__module-link-lock-icon" />
                            </div>
                        )}
                        <Text
                            className="course-container__module-link-label"
                            typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}
                        >
                            {name}
                        </Text>
                        {!isLocked && (
                            <Text
                                className="course-container__module-link-count"
                                id="library.collection.module.lessonCount"
                                size={Text.SIZE.XL}
                                values={{ count: lessons_count }}
                            />
                        )}
                    </div>
                </TooltipStateful>
            </div>
        </Link>
    );
};
